import { GlobalSettings, appEnv } from '../environmentSettings';
import { organizationConfig } from '../shared-config';
import { Locales, LocalesName } from './types/enums/locale.enum';

export default defineAppConfig({
  availableLocales: [
    {
      code: Locales.DA,
      name: LocalesName.DA,
      iso: 'da-DK',
      flag: 'flag-denmark',
      file: 'da-DK.json'
    }
    // {
    //   code: Locales.EN,
    //   name: LocalesName.EN,
    //   iso: 'en-UK',
    //   flag: 'flag-united-kingdom',
    //   file: 'en-UK.json'
    // }
  ],
  config: {
    formatDateStr: 'D. MMM YYYY',
    formatDateTimeStrLong: 'D. MMM YYYY HH:mm',
    formatTimeStr: 'HH:mm',
    siteUrl: GlobalSettings[appEnv].apiBaseUrl,
    supportedLanguages: ['da-DK'],
    fbAppId: '768292835261807',
    seo: {
      meta: {
        description: organizationConfig.description,
        themeColor: [
          {
            content: organizationConfig.seo.themeColor.dark,
            media: '(prefers-color-scheme: dark)'
          },
          {
            content: organizationConfig.seo.themeColor.light,
            media: '(prefers-color-scheme: light)'
          }
        ],
        twitterCreator: organizationConfig.seo.twitter.creator,
        twitterSite: organizationConfig.seo.twitter.site,
        author: organizationConfig.name,
        colorScheme: organizationConfig.seo.colorScheme,
        applicationName: organizationConfig.name,
        ogSiteName: organizationConfig.name,
        ogLocale: organizationConfig.seo.locale,
        ogType: 'website',
        ogUrl: GlobalSettings[appEnv].apiBaseUrl,
        ogTitle: organizationConfig.name,
        ogImage: organizationConfig.seo.ogImage,
        twitterImage: organizationConfig.seo.twitterImage,
        robots: 'index, follow'
      },
      verification: organizationConfig.seo.verification
    }
  },
  info: {
    siteName: organizationConfig.name,
    phone: organizationConfig.contact.phone,
    address: `${organizationConfig.contact.address.street}, ${organizationConfig.contact.address.postalCode} ${organizationConfig.contact.address.city}`,
    email: organizationConfig.contact.email,
    organization: organizationConfig
  },
  prices: {
    priceBorrow: {
      subscriptionNormalPrice: 19800,
      priceNewInstallation: {
        specialPriceExpiration: new Date('2024-02-01T00:00:00'),
        withPower: {
          creationNormalPrice: 249500,
          specialPrice: 249500
        },
        noPower: {
          creationNormalPrice: 349500,
          specialPrice: 349500
        }
      },
      priceExistingInstallation: {
        specialPriceExpiration: new Date('2024-02-01T00:00:00'),
        withPower: {
          creationNormalPrice: 149500,
          specialPrice: 149500
        },
        noPower: {
          creationNormalPrice: 249500,
          specialPrice: 249500
        }
      }
    },
    priceBuy: {
      subscriptionNormalPrice: 6900,
      priceNewInstallation: {
        specialPriceExpiration: new Date('2024-02-01T00:00:00'),
        withPower: {
          creationNormalPrice: 799500,
          specialPrice: 749500
        },
        noPower: {
          creationNormalPrice: 899500,
          specialPrice: 849500
        }
      },
      priceExistingInstallation: {
        specialPriceExpiration: new Date('2024-02-01T00:00:00'),
        withPower: {
          creationNormalPrice: 499500,
          specialPrice: 499500
        },
        noPower: {
          creationNormalPrice: 599500,
          specialPrice: 599500
        }
      }
    }
  },
  greenbowPrices: {
    powerPriceSubscription: '19 kr./md',
    greenPowerSpotPrice: {
      without: '12,00 øre/kWh',
      with: '14,00 øre/kWh' // not used anymore
    },
    taxRefundRates: {
      withVat: '89,50 øre/kWh', // not used anymore
      withoutVat: '71,60 øre/kWh' // not used anymore
    }
  },
  nuxtIcon: {
    // ...expected properties
  }
});
